import {
  version_default
} from "./chunk-HKGC3AKF.mjs";

// config.public.ts
var YWT_PUBLIC_CONFIG = {
  version: version_default[0],
  staticHosting: {
    salesClosed: false
  },
  backend: {
    url: "https://api.ywt.ch",
    stripe: {
      publicKey: "pk_live_51P5Qs12KITU475SmipyAjyW3xH3WfzH43La6JxGlTIWTn9EgNvUFCVQbkypJdkMZ4Vt4I0vqb86K70G9MsAhEC4O00JcMxTml9"
    },
    powerdns: {
      nameservers: ["ns1.ywt.ch", "ns2.ywt.ch"]
    },
    staticHosting: {
      baseDomain: "ywt.app",
      routerHostname: "router.ywt.ch",
      routerIPv4: "162.55.181.224"
    }
  },
  firebase: {
    apiKey: "AIzaSyBW2DfYn7ZfWqpTw6McQG53-Zik1PVvnFU",
    authDomain: "ywt.ch"
  },
  docsUrl: "https://docs.ywt.ch",
  statusUrl: "https://status.ywt.ch",
  environment: "production",
  // Microsoft Clarity project that receives this environment's web analytics.
  // Empty disables Clarity and the consent banner (local).
  clarity: { projectId: "yrhe0dty02" },
  sentry: {
    frontend: { dsn: "https://76727139f7f6b997e3292ff4161bf44c@o4511291171995648.ingest.de.sentry.io/4511291185037392" }
  }
};
export {
  YWT_PUBLIC_CONFIG
};
